import { NewsItem } from "@ha/data/basic";
import { Selector } from "@ngxs/store";

import { Home } from "../models/home.model";
import { HomeState, HomeStateModel } from "./home.state";

export class HomeSelectors {
    @Selector([HomeState])
    public static data(state: HomeStateModel): Home {
        return state.data;
    }

    @Selector([HomeState])
    public static newsItems(state: HomeStateModel): NewsItem[] {
        return state.newsItems;
    }
}
